/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Merge, ValueOf } from 'type-fest';

const successStatuses = ['success', 200];

export const statusCodesMapper = <
  Data,
  Error,
  Statuses extends string,
  Handlers extends Merge<
    Partial<Record<Statuses, (error: NonNullable<Error>) => any>>,
    {
      success?: (data: NonNullable<Data>) => any;
      unhandled: (error: NonNullable<Error>) => any;
    }
  >,
>(
  response: { status: Statuses; error: Error; data?: Data },
  handlers: Handlers
): Handlers extends Record<'success', any>
  ? ReturnType<NonNullable<ValueOf<Handlers>>>
  : ReturnType<NonNullable<ValueOf<Handlers>>> | NonNullable<Data> => {
  if (successStatuses.includes(response.status) || !response.status) {
    return handlers.success
      ? handlers.success(response.data as NonNullable<Data>)
      : (response.data as NonNullable<Data>);
  }

  const givenStatusHandler = handlers[response.status as keyof typeof handlers];

  return givenStatusHandler
    ? givenStatusHandler(response.error as NonNullable<Error>)
    : handlers.unhandled(response.error as NonNullable<Error>);
};
